import React, { Component } from "react";
import PropTypes from "prop-types";
import NumberFormat from "react-number-format";
import Row from "../../shared_modules/common/grid/Row";
import Col from "../../shared_modules/common/grid/Col";
import ValidationMsg from "../../shared_modules/common/forms/ValidationMsg";

class Phone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      msgData: {
        errors: { phone: {} },
        info: { phone: {} },
      },
    };
  }

  static defaultProps = {
    element: {
      name: "phone",
      prefix: "pf-contact-",
      id: "pf-contact-phone",
      label: "Primary Phone",
      label2: "Number",
      placeHolder: "(321) 321-4321",
      colLabelClassName: "label",
      colFieldClassName: "field",
      colValidationClassName: "messaging",
    },
    colLayout: {
      1: { sm: 12, lg: 3 },
      2: { sm: 12, lg: 3 },
      3: { sm: 12, lg: 6 },
    },
  };

  initMsgObj = () => {
    const { element } = this.props,
      msgData = {
        errors: {},
        info: {},
      };

    msgData.errors[element.name] = {};
    msgData.info[element.name] = {};

    return msgData;
  };

  generateMessage = (msgType, customMsg = "") => {
    const { element } = this.props,
      msgKey = msgType === "error" ? "errors" : "info",
      msgData = this.initMsgObj();

    let msg = "";

    if (msgType === "info") {
      msg =
        "By providing your phone number, you agree to receive communications via telephone (including prerecorded or artificial voice message calls, text messages, and calls made by an automatic telephone dialing system) regarding your application or relationship with us.";
    } else if (msgType === "error") {
      msg = "A valid Primary phone number is required, such as (111) 222-3333";
    }

    msgData[msgKey][element.name] = {
      type: msgType,
      msg: customMsg.length > 0 ? customMsg : msg,
      id: element.id,
      slug: element.name,
    };

    return msgData;
  };

  validKey = (ev) => {
    const ZERO = "0",
      NINE = "9",
      ARROWLEFT = "ArrowLeft",
      ARROWRIGHT = "ArrowRight",
      DELETE = "Delete",
      BACKSPACE = "Backspace",
      TAB = "Tab",
      key = ev.key;

    if (
      !(
        (key >= ZERO && key <= NINE) ||
        key === ARROWLEFT ||
        key === ARROWRIGHT ||
        key === DELETE ||
        key === BACKSPACE ||
        key === TAB
      )
    ) {
      ev.preventDefault();
    }
  };

  handleValueChange = (valueObj, ev) => {
    const { fieldMetadata } = this.props;
    fieldMetadata.value = valueObj.value;
  };

  handleBlur = (ev) => {
    const { onEventCallback, fieldMetadata } = this.props;
    let msgData = this.initMsgObj();

    if (fieldMetadata.value.length !== 10) {
      msgData = this.generateMessage("error");
      fieldMetadata.status = "invalid";
      fieldMetadata.isValid = false;
    } else {
      fieldMetadata.status = "";
      fieldMetadata.isValid = true;
    }

    if (onEventCallback && typeof onEventCallback === "function") {
      onEventCallback(ev, fieldMetadata);
    }

    this.setState({
      msgData,
    });
  };

  handleFocus = (ev) => {
    const { fieldMetadata } = this.props;

    fieldMetadata.status = "";
    this.setState({
      msgData: this.generateMessage("info"),
    });
  };

  render() {
    const { colLayout, element, fieldMetadata } = this.props;
    let { msgData } = this.state;

    if (fieldMetadata.status === "invalid") {
      msgData = this.generateMessage("error");
    }

    return (
      <Row className={element.id}>
        <Col className={element.colLabelClassName} width={colLayout[1]}>
          <label className="label-split" htmlFor={element.id}>
            <span className="text">{element.label}</span>
            <span className="text">{element.label2}</span>
          </label>
        </Col>
        <Col className={element.colFieldClassName} width={colLayout[2]}>
          <NumberFormat
            key={fieldMetadata.value}
            id={element.id}
            name={element.name}
            className={fieldMetadata.status}
            type="tel"
            format="(###) ###-####"
            mask="_"
            placeholder={element.placeHolder}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            onValueChange={this.handleValueChange}
            defaultValue={fieldMetadata.value}
            autoComplete={fieldMetadata.autocomplete || null}
          />
        </Col>
        <Col className={element.colValidationClassName} width={colLayout[3]}>
          <ValidationMsg
            who={element.name}
            filterFields={[element.name]}
            msgs={msgData}
          />
        </Col>
      </Row>
    );
  }
}

Phone.propTypes = {
  colLayout: PropTypes.object.isRequired,
  element: PropTypes.object.isRequired,
  onEventCallback: PropTypes.func,
  fieldMetadata: PropTypes.object.isRequired,
};

export default Phone;

require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/pages/borrower-registration/styles/borrower-registration.scss');